// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import cn from 'classnames';
import {use_root, use_can_be_root} from '@pub/hooks.js';
import * as cns from './root_zone.module.less';

export function Root_zone({
    className,
    as='div',
    no_border,
    children,
    possible_root,
})
{
    const is_root = use_root();
    const can_be_root = use_can_be_root();
    const flag = possible_root ? can_be_root : is_root;
    if (!flag)
        return null;
    const Tag = as;
    return <Tag className={cn(cns.root,
      no_border&&cns.root__borderless, className)}>
      {children}
    </Tag>;
}
